<template>
  <div style="height:100%;">
    <van-nav-bar
      title="活动排名"
      left-text=""
      left-arrow
      @click-left="onClickLeft()">
    </van-nav-bar>

    <van-tabs>
      <van-tab title="年度排名">
        <div class="rank">

          <div class="background-image-div3">
            <div style="text-align:center;padding-top:50px;height:26px;">
              <div style="float:left;width:50%;height:100%;font-weight: bold;font-size: 1.25rem;color:white;">
                我的排名
              </div>
              <div style="float:left;width:50%;height:100%;font-weight: bold;font-size: 1.25rem;color:white;">
                距上一名单量
              </div>
            </div>
            <div style="text-align:center;height:23px;">
              <div style="float:left;width:50%;height:100%;font-size: 1.25rem;color:white;" v-if="rank>0">
                {{rank}}
              </div>
              <div style="float:left;width:50%;height:100%;font-size: 1.25rem;color:white;" v-else>
                未入榜
              </div>
              <div style="float:left;width:50%;height:100%;font-size: 1.25rem;color:white;">
                {{diffcount}}
              </div>
            </div>
          </div>
          <div>
            <img src="../../assets/draw2024/rank2025.png" style="width:100%" />
          </div>
        </div>
      </van-tab>
    </van-tabs>

  </div>
</template>

<script>
import { Row, Col, Icon, Cell, CellGroup, Grid, GridItem, Tabs, Tab, NavBar,Progress } from "vant";
import { Button, Field } from "vant";
import { Divider } from "vant";
import { Popup } from "vant";
import { CountDown } from "vant";
import wx from "weixin-js-sdk";
export default {
  name: "MyRank",
  data() {
    return {
      rank:0,
      diffcount:0,
    };
  },
  props: {},
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    GetData() {
      var that = this;
      if (this.isLogined) {
        that.$http.get("SDWorker/Year2025Rank").then((res) => {
          that.rank = res.data.Data.Rank;
          that.diffcount = res.data.Data.DiffCount;
        });
      }   
    },
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  created() {
    console.log(this.user);
    this.GetData();
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [CountDown.name]: CountDown,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [NavBar.name]: NavBar,
    [Progress.name]: Progress,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

html,
body,
div,
dl,
dt,
dd,
ol,
ul,
li,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
button,
fieldset,
form,
input,
legend,
textarea,
th,
td {
  margin: 0;
  padding: 0;
}

.aui-flex {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  padding: 15px;
  position: relative;
}

/* 必要布局样式css */
.aui-flexView {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
}

.aui-scrollView {
  width: 100%;
  height: 100%;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  position: relative;
}

.aui-palace {
  padding: 0.5rem 0;
  position: relative;
  overflow: hidden;
}

.aui-palace-grid {
  position: relative;
  float: left;
  padding: 1px;
  width: 25%;
  box-sizing: border-box;
  margin: 5px 0;
}

.aui-palace-grid-icon {
  width: 30px;
  height: 30px;
  margin: 0 auto;
}

.aui-palace-grid-icon img {
  display: block;
  width: 100%;
  height: 100%;
  border: none;
}

.aui-palace-grid-text {
  display: block;
  text-align: center;
  color: #333;
  font-size: 0.85rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-top: 0.2rem;
}

.aui-palace-grid-text h2 {
  font-size: 0.8rem;
  font-weight: normal;
}

.aui-flex-three {
  background: #fff;
  margin: 1rem;
  border-radius: 5px;
}



.aui-arrow {
  text-align: right;
  color: #394154;
  padding-right: 12px;
  position: relative;
  font-size: 0.85rem;
}

.aui-arrow span {
  color: #999;
  font-size: 0.8rem;
}

.aui-arrow:after {
  content: " ";
  display: inline-block;
  height: 6px;
  width: 6px;
  border-width: 2px 2px 0 0;
  border-color: #999999;
  border-style: solid;
  -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
  transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
  position: relative;
  top: -2px;
  position: absolute;
  top: 50%;
  margin-top: -4px;
  right: 2px;
  border-radius: 1px;
}

.aui-flex-box h4 {
  text-align: center;
  font-weight: normal;
  color: #555555;
}

.aui-flex-box h4 em {
  font-style: normal;
  font-size: 0.9rem;
  font-weight: bold;
  color: #333;
}

.aui-flex-three {
  padding: 0.8rem;
}

.aui-flex-three .aui-flex-box-info:after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  border-right: 1px solid #d9d9d9;
  -webkit-transform: scaleX(0.5);
  transform: scaleX(0.5);
  -webkit-transform-origin: 100% 0;
  transform-origin: 100% 0;
  z-index: 22;
}

.aui-flex-box h1 {
  font-size: 1.17em;
  margin-block-start: 1em;
  margin-block-end: 1em;
}

.points-box {
  height: 80px;
  margin: 0 10px;
  text-align: center;
}
.van-grid {
  border-radius: 5px;
  margin-top: 5px;
  height: 80px;
  overflow: hidden;
}
.van-grid-item__content {
  padding: 4px;
}
.balance-text {
  margin-top: 0;
  font-size: 10px;
}
.balance-name {
  color: #666;
}
.balance-value {
  font-size: 12px;
  font-weight: bold;
  margin-top: 4px;
  color: #b00;
}


.aui-palace2 {
  padding: 0.2rem 0;
  position: relative;
  overflow: hidden;
}

.aui-palace-grid2 {
  position: relative;
  float: left;
  padding: 1px;
  width: 50%;
  box-sizing: border-box;
  margin: 5px 0;
}

.aui-palace-grid-icon2 {
  width: 30px;
  height: 30px;
  margin: 0 auto;
}

.aui-palace-grid-text2 {
  display: block;
  text-align: center;
  color: #333;
  font-size: 0.85rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-top: 0.5rem;
}

.aui-palace-grid-text2 h2 {
  font-size: 0.8rem;
  font-weight: normal;
}

.aui-palace-grid-text2 h1 {
  font-size: 1.2rem;
  font-weight: normal;
  font-weight: bold;
}

.aui-flex2 {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  padding: 10px;
  position: relative;
}

.aui-take-item {
  background: #fff;
  border-radius: 5px;
  margin: 0.5rem;
}

.aui-flex-box {
  -webkit-box-flex: 1;
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #333;
  text-align: left;
}

.rank {
  height: 100%;
  width: 100%;
  position: relative;
  background-image: url('../../assets/draw2024/level_bg.jpg');
  background-repeat:no-repeat;
  overflow: hidden;
  background-size: cover;
  z-index: -2;;
}

.background-image-div {
  width: 100%; /* 设置div的宽度 */
  height: 15%; /* 设置div的高度 */
  background-image: url('../../assets/draw2024/rank1_1.png'); /* 设置背景图片 */
  background-size: cover; /* 背景图片覆盖整个div区域 */
  background-position: center; /* 背景图片居中 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  z-index: -1;
  margin-top:5%;
  color: rgba(255, 215, 0, 0.5);
}

.background-image-div2 {
  width: 100%; /* 设置div的宽度 */
  height: 15%; /* 设置div的高度 */
  background-image: url('../../assets/draw2024/rank2_1.png'); /* 设置背景图片 */
  background-size: cover; /* 背景图片覆盖整个div区域 */
  background-position: center; /* 背景图片居中 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  z-index: -1;
  margin-top:5%;
  color: rgba(255, 215, 0, 0.5);
}

.background-image-div3 {
  width: 100%; /* 设置div的宽度 */
  height: 15%; /* 设置div的高度 */
  background-image: url('../../assets/draw2024/rank3_1.png'); /* 设置背景图片 */
  background-size: cover; /* 背景图片覆盖整个div区域 */
  background-position: center; /* 背景图片居中 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  z-index: -1;
  margin-top:5%;
  color: rgba(255, 215, 0, 0.5);
}
</style>
